import {Injectable} from '@angular/core';
import {ActivatedRouteSnapshot, CanActivate, Route, Router, RouterStateSnapshot} from '@angular/router';
import {Observable} from 'rxjs/Observable';
import {PermissionService} from '@shared/service/permission.service';
import {Utilities} from '@shared/utilities/utilities.model';
import {ROOT_NOT_FOUND_PAGE} from './app-routing-roots';
import {DATA_KEY_PROFILES} from './modules-loading.guard';

export const DATA_KEY_PERMISSION: string = 'permission';
export const CHECK_SOME_PERMISSION: string = 'checkSomePermission';
export const DATA_KEY_PROFILE_WHITE_LIST	: string = 'profileWhiteList';
export const DATA_KEY_PROFILE_BLACK_LIST	: string = 'profileBlackList';

@Injectable()
export class PermissionGuard implements CanActivate {

	constructor(private permissionService: PermissionService, private router: Router) {
	}

	canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
		return new Observable<boolean>(observer => {
			const profiles = Utilities.getValueFromRoute(next.root.firstChild as Route, DATA_KEY_PROFILES) as string[];
			const permissions = Utilities.getValueFromRoute(next as Route, DATA_KEY_PERMISSION);
			if (!Utilities.isVoid(profiles)) {
				this.permissionService.getUserV3Permission()
					.subscribe(
						userPermissions => {

							const hasPermission = userPermissions.hasPermissions(permissions);
							if (!hasPermission) {
								this.router.navigate([ROOT_NOT_FOUND_PAGE]);
							}
							observer.next(hasPermission);
							observer.complete();
						}, error => {
							this.router.navigate([ROOT_NOT_FOUND_PAGE]);
							observer.next(false);
							observer.complete();
						});
			} else {
				observer.next(true);
				observer.complete();
			}
		});
	}
}
